export const Z_FIRST_TIER = 99;
export const Z_SECOND_TIER = 999;
export const Z_THIRD_TIER = 9999;
